/*
 * CASA BELLA sticky add-to-cart bar (snippets/cart-bar.liquid): size select that drives the
 * product form, and a button that uses the form's own add-to-cart button.
 */
(function () {
  function norm(value) {
    return String(value == null ? '' : value).trim().toUpperCase();
  }

  function setup(bar) {
    if (bar.hasAttribute('data-cb-bar-ready')) return;
    bar.setAttribute('data-cb-bar-ready', '');

    var config = JSON.parse(bar.querySelector('[data-cb-bar-config]').textContent);
    var index = config.sizePosition - 1;
    var section = bar.closest('[data-section-id]') || document;
    var select = bar.querySelector('[data-cb-bar-size]');
    var hint = bar.querySelector('[data-cb-bar-hint]');
    var colorSelect = bar.querySelector('[data-cb-bar-color]');
    var W = config.words || ['Cor', 'Tamanho', 'Esgotado', 'Indisponível'];
    var sizes = [];
    config.variants.forEach(function (variant) {
      if (sizes.indexOf(variant.options[index]) === -1) sizes.push(variant.options[index]);
    });

    function selectors(position) {
      return section.querySelectorAll('[data-single-option-selector][data-index="option' + position + '"]');
    }

    function currentValue(position) {
      var value = null;
      selectors(position).forEach(function (input) {
        if (input.type === 'radio' ? input.checked : true) value = input.value;
      });
      return value;
    }

    function variantFor(size) {
      return config.variants.filter(function (variant) {
        return variant.options.every(function (value, i) {
          if (i === index) return value === size;
          var current = currentValue(i + 1);
          return current == null || value === current;
        });
      })[0] || null;
    }

    function render() {
      var chosen = select.value;
      select.innerHTML = '<option value="">' + W[1] + '</option>' + sizes.map(function (size) {
        var variant = variantFor(size);
        var available = variant && variant.available;
        var label = size + (variant ? (available ? '' : ' · ' + W[2]) : ' · ' + W[3]);
        return '<option value="' + size.replace(/"/g, '&quot;') + '"' + (available ? '' : ' disabled') + '>' + label + '</option>';
      }).join('');
      var still = chosen && variantFor(chosen);
      select.value = still && still.available ? chosen : '';
    }

    // Choosing an option in the bar selects it in the product form, as a customer click would.
    function pick(position, value) {
      var wrapper = section.querySelector('[data-option-position="' + position + '"]');
      if (!wrapper) return;
      var done = false;
      wrapper.querySelectorAll('input[type="radio"][data-single-option-selector]').forEach(function (radio) {
        if (!done && norm(radio.value) === norm(value)) { radio.click(); done = true; }
      });
      if (!done) {
        wrapper.querySelectorAll('[data-popout-option]').forEach(function (option) {
          if (!done && norm(option.getAttribute('data-value')) === norm(value)) { option.click(); done = true; }
        });
      }
    }
    if (colorSelect) {
      colorSelect.addEventListener('change', function () { pick(config.colorPosition, colorSelect.value); });
    }
    select.addEventListener('change', function () {
      hint.hidden = true;
      select.parentNode.classList.remove('is-required');
      if (!select.value) return;
      var wrapper = section.querySelector('[data-option-position="' + config.sizePosition + '"]');
      if (!wrapper) return;
      var done = false;
      wrapper.querySelectorAll('input[type="radio"][data-single-option-selector]').forEach(function (radio) {
        if (!done && norm(radio.value) === norm(select.value)) {
          radio.click();
          done = true;
        }
      });
      if (!done) {
        wrapper.querySelectorAll('[data-popout-option]').forEach(function (option) {
          if (!done && norm(option.getAttribute('data-value')) === norm(select.value)) {
            option.click();
            done = true;
          }
        });
      }
    });

    // Both buttons reuse the product form's own buttons (theme add-to-cart / CASA BELLA buy now).
    function needsSize() {
      if (select.value) return false;
      hint.hidden = false;
      select.parentNode.classList.add('is-required');
      select.focus();
      return true;
    }

    bar.querySelector('[data-cb-bar-add]').addEventListener('click', function () {
      if (needsSize()) return;
      var add = section.querySelector('[data-add-to-cart]:not([data-add-to-cart-bar])');
      if (add && !add.disabled) add.click();
    });

    var buy = bar.querySelector('[data-cb-bar-buy]');
    var mainBuy = null;
    section.querySelectorAll('[data-cb-buy-now]').forEach(function (b) {
      if (!mainBuy && !bar.contains(b)) mainBuy = b;
    });
    if (!mainBuy) {
      buy.hidden = true;
    } else {
      buy.addEventListener('click', function () {
        if (needsSize()) return;
        if (!mainBuy.disabled) mainBuy.click();
      });
    }

    // Keep the list in step with the product form (colour changes, or a size picked up top).
    section.addEventListener('change', function (event) {
      if (!event.target.matches('[data-single-option-selector]')) return;
      render();
      if (colorSelect && event.target.getAttribute('data-index') === 'option' + config.colorPosition) {
        var c = currentValue(config.colorPosition);
        if (c) colorSelect.value = c;
      }
      if (event.target.getAttribute('data-index') === 'option' + config.sizePosition) {
        var picked = currentValue(config.sizePosition);
        var variant = picked && variantFor(picked);
        if (variant && variant.available) select.value = picked;
      }
    });

    render();
  }

  // Only allow the bar once the product form's own add-to-cart button has scrolled up out of view.
  function watch(cartBar) {
    if (cartBar.hasAttribute('data-cb-bar-watched') || !('IntersectionObserver' in window)) return;
    var section = cartBar.closest('[data-section-id]') || document;
    var button = null;
    section.querySelectorAll('[data-add-to-cart]').forEach(function (candidate) {
      if (!button && !cartBar.contains(candidate)) button = candidate;
    });
    if (!button) return;
    cartBar.setAttribute('data-cb-bar-watched', '');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        cartBar.classList.toggle('cb-bar-allowed', passed);
      });
    }).observe(button);
  }

  function init() {
    document.querySelectorAll('[data-cb-bar]').forEach(function (bar) {
      try { setup(bar); } catch (error) { bar.hidden = true; }
    });
    document.querySelectorAll('#cart-bar').forEach(watch);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
